module.exports = __webpack_public_path__ + "media/images/thank-desktop-xl-c5c8e8fa045195a16ff81bb9986ea054.jpg";